import {Channel} from "../../../@types/demoPaymentMethodsResources.ts";

const PaymentMethodsSingleChannel = (
    {channel, setSelectedChannel}:
        {channel: Channel, setSelectedChannel: (arg0: string) => void}
) => {

    return (
        <>
            <div className="col-md-6 col-lg-3 pb-4">
                <label className="opy-payment-method">
                    <button
                         className="opy-payment-method__card"
                         style={{background: 'none'}}
                         onClick={() => setSelectedChannel(channel.channel_name)}>
                        <div className="opy-payment-method__logo">
                            <img src={channel.logo_urls.color_33px} alt={channel.title}/>
                        </div>
                    </button>
                </label>
            </div>
        </>
    )
}

export default PaymentMethodsSingleChannel;
